/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreGcpInstanceDiskInput } from '../models/RestoreGcpInstanceDiskInput';

export class GcpVmInstanceRestoreTarget {
  /**
  * Zone to restore to.
  */
  'zone': string;
  /**
  * Machine type to use.
  */
  'machineType': string;
  /**
  * VM name.
  */
  'name': string;
  /**
  * Name of the VPC network to use.
  */
  'networkName': string;
  /**
  * Name of the subnet to use.
  */
  'subnetName': string;
  /**
  * ID of the project that hosts the VPC network. Applicable only when restoring to a shared VPC network. 
  */
  'networkHostProject'?: string;
  /**
  * Labels to apply to the restored VM as key-value pairs, where key and value are both strings. These labels are always applied: `\"eon-restore\": \"true\"`.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'labels'?: { [key: string]: string; };
  /**
  * Disks to restore and attach to the restored instance. Each item in the list corresponds to a disk to be restored, where `providerDiskId` matches the disk\'s ID at the time of the snapshot. The boot disk must be in the list. 
  */
  'disks': Array<RestoreGcpInstanceDiskInput>;
  /**
  * Whether to start the VM instance after restoring it. If set to `false`, the VM will be created in a stopped state. 
  */
  'startInstanceAfterRestore'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "machineType",
      "baseName": "machineType",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkName",
      "baseName": "networkName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetName",
      "baseName": "subnetName",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkHostProject",
      "baseName": "networkHostProject",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "disks",
      "baseName": "disks",
      "type": "Array<RestoreGcpInstanceDiskInput>",
      "format": ""
    },
    {
      "name": "startInstanceAfterRestore",
      "baseName": "startInstanceAfterRestore",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpVmInstanceRestoreTarget.attributeTypeMap;
  }

  public constructor() {
  }
}

